class ProductRecommendationCarousel extends HTMLElement {
  constructor () {
    super()

    this.desktopBreakpoint = 990

    this.slidesEl = this.querySelector(
      '[data-product-recommendation-carousel-el="slider"]',
    )
    this.slideEls = this.querySelectorAll(
      '[data-product-recommendation-carousel-el="slide"]',
    )

    this.prevEl = this.querySelector(
      '[data-product-recommendation-carousel-el="prev"]',
    )
    this.nextEl = this.querySelector(
      '[data-product-recommendation-carousel-el="next"]',
    )

    if (this.slideEls.length < 2 || window.innerWidth > this.desktopBreakpoint) return

    this.carousel = this.initialiseCarousel()

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener('resize', () => {
      if (window.innerWidth > this.desktopBreakpoint && this.carousel) {
        this.carousel.destroy()
        this.carousel = null
      } else if (!this.carousel) {
        this.carousel = this.initialiseCarousel()
      }
    })
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.slidesEl,
      {
        slides: {
          perView: '2',
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.plugins.useInitialised(),
        window.BAO.Carousel.plugins.useArrows({
          next: this.nextEl,
          previous: this.prevEl,
        }),
      ],
    )
  }
}

if (!customElements.get('product-recommendation-carousel')) {
  customElements.define('product-recommendation-carousel', ProductRecommendationCarousel)
}
